__turbopack_context__.v({
  "align-center": "text-module-scss-module__GCMV3W__align-center",
  "align-justify": "text-module-scss-module__GCMV3W__align-justify",
  "align-left": "text-module-scss-module__GCMV3W__align-left",
  "align-right": "text-module-scss-module__GCMV3W__align-right",
  "bold": "text-module-scss-module__GCMV3W__bold",
  "italic": "text-module-scss-module__GCMV3W__italic",
  "size-l": "text-module-scss-module__GCMV3W__size-l",
  "size-m": "text-module-scss-module__GCMV3W__size-m",
  "size-s": "text-module-scss-module__GCMV3W__size-s",
  "size-xs": "text-module-scss-module__GCMV3W__size-xs",
  "spacing": "text-module-scss-module__GCMV3W__spacing",
  "text": "text-module-scss-module__GCMV3W__text",
});
